<template>
<!-- Uploader communicates with the Parent with Props and Emit -->
<!-- The Upload Path is passed using the :uploadPath="" directive in the parent -->
<!-- The file upload promise return is sent back to the parent via the @filesUploaded="[parentFunctionName]" on the parent -->
<v-container>
  <v-layout row wrap>
    <!-- Revision Date Picker for Plans -->
    <v-flex mb-4 v-if="singleOnly">
      <v-flex xs12 sm6 md4>
        <v-toolbar flat dark height="40px" color="primary">
          <v-toolbar-title>Plan Revision Date</v-toolbar-title>
        </v-toolbar>
        <v-menu ref="menu" :close-on-content-click="true" v-model="dateMenu" nudge-right="40" nudge-top="200" :return-value.sync="dateMenu" lazy transition="scale-transition" offset-y full-width min-width="290px">
          <v-text-field slot="activator" v-model="fileVersion" prepend-icon="event" readonly></v-text-field>
          <v-date-picker v-model="fileVersion" no-title scrollable>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-flex>
    <!-- End: Revision Date Picker for Plans -->
    <v-toolbar style="height: 60px" color="primary" dark>
      <v-icon>cloud_upload</v-icon>
        <v-toolbar-title>
          <span>File Uploader</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="showUploadButton" class="orange white--text" @click="executeFileUpload"><v-icon left>cloud_upload</v-icon>Upload Files</v-btn>
        <v-btn @click="$emit('closeUploader')" flat icon><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-toolbar v-if="error || warning" height="40px" :class="{ 'red': error, 'yellow': warning }">
      <v-toolbar-title v-if="warning">{{ warning }}</v-toolbar-title>
      <v-toolbar-title v-if="error">{{ error }}</v-toolbar-title>
    </v-toolbar>
    <v-flex v-if="!progressBar">
      <div id='app'>
      <vue-dropzone ref="myVueDropzone" @vdropzone-files-added="resizePhotos" v-on:vdropzone-files-added="sendingEvent" :options="singleOnly ? dropzoneOptionsSingle : photos ? dropzoneOptionsPhotos : dropzoneOptions" id="dropzone"></vue-dropzone>
      </div>
        <div class="text-xs-center">
          <v-btn id="browse" class="secondary white--text" style="height: 70px; width: 200px"><v-icon left>cloud_upload</v-icon>Browse Files</v-btn>
          <v-btn v-if="showUploadButton" class="orange white--text" style="height: 70px; width: 200px" @click="executeFileUpload"><v-icon left>cloud_upload</v-icon>Upload Files</v-btn>
        </div>
      <h2 v-if="fileSuccess" class="success--text text-xs-center">Files Uploaded Successfully!</h2>
    </v-flex>
    <v-flex v-if="progressBar" class="text-xs-center mt-3">
      <h1>Uploading Files... Please Wait</h1>
    <v-progress-linear height="20" :indeterminate="true"></v-progress-linear>
    </v-flex>
    <!-- <v-btn @click="getTest">Test</v-btn> -->
  </v-layout>
</v-container>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import { storage } from '../firebaseInit'

export default {
  props: ['uploadPath', 'singleOnly', 'photos'],
  data: () => ({
    maxWidth: 1600,
    thumbnailSize: 300,
    showUploadButton: false,
    dateMenu: null,
    fileVersion: null,
    reader: null,
    files: [],
    error: false,
    warning: false,
    progressBar: false,
    fileSuccess: false,
    dropzoneOptionsSingle: {
      clickable: '#browse',
      url: '#',
      maxFilesize: 20,
      maxFiles: 1,
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictDefaultMessage: "<i class='fas fa-file-upload fa-5x'></i><p style='font-size: 22px'>Drag Here to Upload a PDF Pool Print</p>"
    },
    dropzoneOptions: {
      clickable: '#browse',
      url: '#',
      maxFilesize: 20,
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictDefaultMessage: "<i class='fas fa-file-upload fa-5x'></i><p style='font-size: 22px'>Drag Files Here To Add The Files</p>"
    },
    dropzoneOptionsPhotos: {
      clickable: '#browse',
      url: '#',
      maxFilesize: 20,
      autoProcessQueue: false,
      acceptedFiles: 'image/*',
      addRemoveLinks: true,
      dictDefaultMessage: "<i class='fas fa-file-upload fa-5x'></i><p style='font-size: 22px'>Drag Files Here To Add The Files</p>"
    }
  }),
  mounted () {
    if (this.singleOnly) {
      this.warning = 'Upload only a single "PDF" Pool Print file'
      // this.fileVersion = new Date().toISOString().substring(0, 10)
    }
  },
  computed: {
    currentFileLoad () {
      return this.$store.getters.currentFileLoad
    }
  },
  watch: {
    currentFileLoad () {
      this.sendForResize()
    },
    fileVersion () {
      this.$emit('planVersion', this.fileVersion)
    }
  },
  methods: {
    errorSingleOnly () {
      this.warning = false
      this.error = 'Upload only a single "PDF" file'
    },
    executeFileUpload () {
      if (this.singleOnly && !this.fileVersion) {
        alert('You must enter a version date for the pool print to continue')
        return
      }
      this.progressBar = true
      this.$refs.myVueDropzone.removeAllFiles(true)
      if (this.photos) {
        this.uploadPhotos()
      } else {
        this.uploadFiles()
      }
      this.error = false
    },
    sendingEvent (file) {
      this.showUploadButton = true
      if ((this.singleOnly && this.files.length > 0) || (this.singleOnly && file.length > 1)) {
        this.errorSingleOnly()
        this.$refs.myVueDropzone.removeFile(file)
      } else if (this.photos) {
        console.log('Uploading Photos... Please Wait...')
      } else {
        this.fileSuccess = false
        let i
        for (i = 0; i < file.length; i++) {
          if (this.singleOnly) {
            const fileName = file[i].name.replace(/\.[^/.]+$/, '')
            const fileExtension = file[i].name.split('.').pop()
            let newFile = new File([file[i]], fileName + '-V-' + this.fileVersion + '.' + fileExtension, {type: file[i].type})
            this.files.push(newFile)
          } else {
            let newFile = new File([file[i]], file[i].name, {type: file[i].type})
            this.files.push(newFile)
          }
        }
      }
    },
    uploadFiles () {
      this.progressBar = true
      const storageRef = storage.ref(this.uploadPath)
      storage.ref().constructor.prototype.putFiles = function (files) {
        var ref = this
        const filesArray = [...files]
        return Promise.all(filesArray.map(function (file) {
          return ref.child(file.name).put(file)
        }))
      }
      storageRef.putFiles(this.files)
      .then(uploadedFiles => {
        this.fileSuccess = true
        this.progressBar = false
        this.$emit('filesUploaded', uploadedFiles)
        this.$emit('closeUploader')
      }).catch(function (error) {
        console.log(error)
      })
    },
    uploadPhotos () {
      console.log('Uploading Photos...')
      let uploadedPhotos = []
      let fileCount = 0
      this.files.forEach(file => {
        const storageRef = storage.ref(this.uploadPath + file.name)
        storageRef.putString(file.base64, 'data_url').then(snapshot => {
          console.log(snapshot)
          uploadedPhotos.push(snapshot)
          console.log('Uploaded Photos!')
          fileCount++
          if (fileCount === this.files.length) {
            this.$emit('filesUploaded', uploadedPhotos)
            this.progressBar = false
            this.$emit('closeUploader')
          }
        })
      })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    // Start: Resize Code
    resizePhotos (files) {
      if (!this.photos) {
        return
      }
      const fileList = Object.values(files)
      let fileCount = 0
      this.asyncForEach(fileList, async (file) => {
        await new Promise(resolve => {
          console.log('Got New Promise')
          this.reader = new FileReader()
          this.reader.readAsDataURL(file) // Handles the Async load of Base64
          this.reader.onload = event => {
            // Rename Image
            let milliseconds = String((new Date()).getTime())
            let timestamp = milliseconds + '-' + Math.floor(Math.random() * 1000)
            // Make a fileInfo Object
            let fileInfo = {
              name: timestamp,
              type: file.type,
              size: Math.round(file.size / 1000) + ' kB',
              base64: this.reader.result
            }
            // Recreate Canvas Element
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let img = new Image()
            let thumbnail = new Image()
            img.src = fileInfo.base64
            // return new Promise(resolve => {
            img.onload = () => {
              if (img.width < this.maxWidth) {
                this.files.push({base64: fileInfo.base64, name: fileInfo.name})
                resolve({fileInfo: fileInfo, thumbnail: thumbnail, ctx: ctx, img: img, canvas: canvas})
                return // Kick out if already smaller then the resized size
              }
              // Build Image URL
              let scale = this.maxWidth / img.width
              let width = Math.round(img.width * scale)
              let height = Math.round(img.height * scale)
              // Set Canvas Height And Width According to Image Size And Scale
              canvas.setAttribute('width', width)
              canvas.setAttribute('height', height)
              ctx.drawImage(img, 0, 0, width, height)
              let base64 = canvas.toDataURL('image/jpeg')
              // Send to Files
              this.files.push({base64: base64, name: fileInfo.name})
              console.log('Resize Completed!')
              resolve({fileInfo: fileInfo, thumbnail: thumbnail, ctx: ctx, img: img, canvas: canvas})
            }
          }
        }).then((data) => {
          const ctx = data.ctx
          const img = data.img
          const thumbnail = data.thumbnail
          // Build Thumbnail URL
          thumbnail.src = data.fileInfo.base64
          thumbnail.onload = () => {
            if (thumbnail.width > thumbnail.height) {
              let adjustment = this.thumbnailSize / thumbnail.width
              thumbnail.width = this.thumbnailSize
              thumbnail.height = Math.round(thumbnail.height * adjustment)
            } else {
              let adjustment = this.thumbnailSize / thumbnail.height
              thumbnail.width = Math.round(thumbnail.width * adjustment)
              thumbnail.height = this.thumbnailSize
            }
            data.canvas.setAttribute('width', thumbnail.width)
            data.canvas.setAttribute('height', thumbnail.height)
            ctx.drawImage(img, 0, 0, thumbnail.width, thumbnail.height)
            let base64 = data.canvas.toDataURL('image/jpeg')
            this.files.push({base64: base64, name: 'thumb_' + data.fileInfo.name})
            fileCount++
            if (fileCount === fileList.length) {
              this.showUploadButton = true
            }
          }
        })
      })
    }
  },
  components: {
    vueDropzone
  },
  template: function () {
    return `<div class="dz-preview dz-file-preview">
            <div class="dz-image">
                <div data-dz-thumbnail-bg></div>
            </div>
            <div class="dz-details">
                <div class="dz-size"><span data-dz-size></span></div>
                <div class="dz-filename"><span data-dz-name></span></div>
            </div>
            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
            <div class="dz-success-mark"><i class="fa fa-check"></i></div>
            <div class="dz-error-mark"><i class="fa fa-close"></i></div>
        </div>
        `
  }
}
</script>

<style>
.dz-progress {
  /* progress bar covers file name */
  display: none !important;
}
.vue-dropzone .dz-preview .dz-details {
  background-color: grey;
}
.vue-dropzone .dz-preview .dz-details .dz-filename {
  font-size: 20px;
}
</style>




// WEBPACK FOOTER //
// src/helpers/Uploader.vue